import {all} from 'redux-saga/effects';
import Sellers from 'src/pages/Sellers/store/sagas';

export default function* RootSaga() {
  yield all([
    Sellers(),
  ]);
}
